module.exports = __webpack_public_path__ + "static/media/bg.74b17cbd.svg";